// src/styles/colors.ts
export const Colors = {
    primary: "#3C5973",
    secondary: "#03dac6",
    error: "#b00020",
    warning: "#ffab00",
    info: "#2196f3",
    success: "#4caf50",
    background: "#3C5973",
    text: {
        primary: "#212121",
        secondary: "#757575",
        disabled: "#9e9e9e",
    },
};